"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var h = require("./../../utils/createElement").h;
var React = tslib_1.__importStar(require("react"));
var PropTypes = tslib_1.__importStar(require("prop-types"));
var context_1 = require("./context");
var theme_1 = require("../../utils/theme");
var TabPane = (function (_super) {
    tslib_1.__extends(TabPane, _super);
    function TabPane() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.themedRender = function (classNames) {
            var _a;
            var _b = _this.props, prefixCls = _b.prefixCls, className = _b.className, style = _b.style, children = _b.children, forceRender = _b.forceRender, id = _b.id;
            var isActive = _this.context === id;
            var shouldRender = isActive || forceRender;
            var classes = classNames(prefixCls, className, (_a = {},
                _a[prefixCls + "-active"] = isActive,
                _a));
            return (h("div", { className: classes, style: style }, shouldRender ? children : null));
        };
        return _this;
    }
    TabPane.prototype.render = function () {
        return theme_1.consumeTheme(this.themedRender);
    };
    TabPane.contextType = context_1.ActiveTabIdContext;
    return TabPane;
}(React.Component));
exports.default = TabPane;
TabPane.defaultProps = {
    prefixCls: 'dui-m-tabpane',
    forceRender: false,
};
TabPane.propTypes = {
    prefixCls: PropTypes.string,
    style: PropTypes.object,
    className: PropTypes.string,
    forceRender: PropTypes.bool,
    id: PropTypes.string,
    tab: PropTypes.node,
    icon: PropTypes.node,
    activeIcon: PropTypes.node,
};
